"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToasts = exports.ToastsProvider = exports.ToastsContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["ttl", "onClose"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var reducer = function reducer(state, action) {
  switch (action.type) {
    case "SEND":
      return _objectSpread(_objectSpread({}, state), {}, {
        toasts: [].concat(_toConsumableArray(state.toasts), [action.payload])
      });
    case "RETRACT":
      return _objectSpread(_objectSpread({}, state), {}, {
        toasts: state.toasts.filter(function (_ref) {
          var id = _ref.id;
          return id !== action.payload.id;
        })
      });
  }
};
var ToastsContext = /*#__PURE__*/(0, _react.createContext)({
  state: {
    toasts: []
  },
  sendToast: function sendToast() {
    return {
      id: "",
      handleClose: function handleClose() {
        // NOOP
      }
    };
  },
  retractToast: function retractToast() {
    // NOOP
  }
});
exports.ToastsContext = ToastsContext;
var ToastsProvider = function ToastsProvider(_ref2) {
  var children = _ref2.children;
  var _useReducer = (0, _react.useReducer)(reducer, {
      toasts: []
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var activeToasts = (0, _react.useRef)(new Map());
  var retractToast = (0, _react.useCallback)(function (id) {
    var _toast$onClose;
    var toast = activeToasts.current.get(id);
    if (!toast) return;
    clearTimeout(toast.timeout);
    activeToasts.current.delete(id);
    dispatch({
      type: "RETRACT",
      payload: {
        id: id
      }
    });
    (_toast$onClose = toast.onClose) === null || _toast$onClose === void 0 ? void 0 : _toast$onClose.call(toast, id);
  }, []);
  var sendToast = (0, _react.useCallback)(function (_ref3) {
    var _ref3$ttl = _ref3.ttl,
      ttl = _ref3$ttl === void 0 ? 6000 : _ref3$ttl,
      onClose = _ref3.onClose,
      rest = _objectWithoutProperties(_ref3, _excluded);
    var id = generateId();
    var handleClose = function handleClose() {
      retractToast(id);
    };
    dispatch({
      type: "SEND",
      payload: _objectSpread(_objectSpread({}, rest), {}, {
        id: id,
        ttl: ttl,
        onClose: handleClose
      })
    });
    activeToasts.current.set(id, {
      timeout: ttl !== Infinity ? window.setTimeout(handleClose, ttl) : -1,
      onClose: onClose
    });
    return {
      id: id,
      handleClose: handleClose
    };
  }, [retractToast]);
  (0, _react.useEffect)(function () {
    var toasts = activeToasts.current;
    return function () {
      toasts.forEach(function (toast) {
        return clearTimeout(toast.timeout);
      });
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(ToastsContext.Provider, {
    value: {
      state: state,
      sendToast: sendToast,
      retractToast: retractToast
    }
  }, children);
};
exports.ToastsProvider = ToastsProvider;
ToastsProvider.displayName = "ToastsProvider";
var useToasts = function useToasts() {
  var _useContext = (0, _react.useContext)(ToastsContext),
    toasts = _useContext.state.toasts,
    sendToast = _useContext.sendToast,
    retractToast = _useContext.retractToast;
  return {
    toasts: toasts,
    sendToast: sendToast,
    retractToast: retractToast
  };
};
exports.useToasts = useToasts;
var generateId = function generateId() {
  return Math.random().toString(26).slice(2);
};
//# sourceMappingURL=useToasts.js.map